import React from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import "./OpalAccordionCardV5.css";

const OpalAccordionCardV5 = ({
    item,
    selectedCard,
    setSelectedCard,
    onSelectItem,
}) => {
    // determine the proper icon and color based on type
    const getIconDetails = (type) => {
        switch (type) {
            case "Plan":
                return { image: "/Images/fe--calendar.svg", color: "#138BE1" };
            case "Leave":
                return { image: "/Images/fe--calendar.svg", color: "#138BE1" };
            case "NewCustomer":
                return { image: "/Images/mdi--building.svg", color: "#069D33" };
            case "MissedCall":
                return { image: "/Images/fe--calendar.svg", color: "#C22020" };
            default:
                return { image: "/Images/fe--calendar.svg", color: "#138BE1" };
        }
    };

    const { image, color } = getIconDetails(item.Type);

    return (
        <Card
            key={item.ID}
            className={`card-v5 mb-2 ${selectedCard === item.ID ? "active-card" : ""} p-3`}
            onClick={() => {
                setSelectedCard(item.ID);
            }}
        >
            <div
                className="card-body d-flex justify-content-between align-items-center"
                style={{ "--color-description": color }}>
                <div className="w-100">
                    <div className="d-flex align-items-center mb-2">
                        <div className="icon-inline me-2">
                            <TauriImage localImage={image} color={color} />
                        </div>
                        <Card.Title className="card-title mb-0">
                            {item.Description}
                        </Card.Title>
                    </div>
                    <Card.Text className="mb-0">
                        {item.Name}
                    </Card.Text>
                </div>
                <div className="arrow-icon">
                    <TauriImage localImage={"/Images/arrow-right.svg"} color={"#B8CCE2"}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCard(item.ID);
                            onSelectItem(item);
                        }} />
                </div>
            </div>
        </Card>
    );
};

export default OpalAccordionCardV5;
